function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.842,
    height: 6.676,
    viewBox: "0 0 23.842 6.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20575",
    transform: "translate(-1205 -353)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 609",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1205 353)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 610",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1213.583 353)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 611",
    cx: 3.338,
    cy: 3.338,
    r: 3.338,
    transform: "translate(1222.166 353)",
    style: {
      fill: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot);
export default __webpack_public_path__ + "static/media/three-dot.b1d55b51bebdc61d86eb67107af7a9cb.svg";
export { ForwardRef as ReactComponent };